/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Label_Pricing_OnInputs */

const fr_label_pricing_on = /** @type {(inputs: Label_Pricing_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Affichée`)
};

const en_label_pricing_on = /** @type {(inputs: Label_Pricing_OnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shown`)
};

/**
* | output |
* | --- |
* | "Shown" |
*
* @param {Label_Pricing_OnInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const label_pricing_on = /** @type {((inputs?: Label_Pricing_OnInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Label_Pricing_OnInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_label_pricing_on(inputs)
	return en_label_pricing_on(inputs)
});